import React, { useState } from 'react'
import styled from 'styled-components'
import { Modal, Toast } from '@seiue/ui'
import { Preview } from './Preview'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { TaskReq } from 'packages/sdks-next/growp'
import { ReqWithMetaData } from '../types'
import { AnyValueObj } from 'packages/types'
import { getTheme } from '@/utils/theme'

/**
 * 问卷预览 - 带全屏弹窗
 *
 * @param param - 参数
 * @param param.task - 任务
 * @param pram.questionnaires - 问卷结构
 * @param param.closePreview - 关闭预览弹窗方法
 * @returns React.ReactNode
 */
export const PreViewModal: React.FC<{
  task: TaskReq
  questionnaires: ReqWithMetaData[]
  closePreview: () => void
}> = ({ task, questionnaires, closePreview }) => {
  const theme = getTheme()
  const [formValues, setFormValues] = useState<AnyValueObj>({})
  const [otherInfo, setOtherInfo] = useState<object>({})
  return (
    <Modal
      fullScreen={true}
      visible={true}
      bodyStyle={{
        backgroundColor: theme.background._4,
      }}
      header={
        <>
          <HeaderWrapper>
            <IconWrapper onClick={closePreview}>
              <GrowpIcon
                name="Right"
                size={20}
              />
            </IconWrapper>
            <Title>{task.name || '未命名的问卷'}</Title>
          </HeaderWrapper>
          <ExtraInfo>
            <GrowpIcon
              name="WarnFill"
              fill="#FF8800"
              size={14}
            />
            <div>本页面为预览模式</div>
          </ExtraInfo>
        </>
      }
    >
      <PreviewWrapper>
        <Preview
          formValues={formValues}
          setFormValues={(v) => setFormValues(v)}
          otherInfo={otherInfo}
          setOtherInfo={(v) => setOtherInfo(v)}
          task={task}
          questionnaires={questionnaires}
          onSubmit={() => {
            Toast.warning('预览模式下不支持数据提交')
          }}
          isPreview={true}
        />
      </PreviewWrapper>
    </Modal>
  )
}

const PreviewWrapper = styled.div`
  padding-bottom: 20px;
`

const HeaderWrapper = styled.div`
  width: 100%;
  min-height: 64px;
  padding-left: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #ffffff;
  box-shadow: inset 0px -1px 0px 0px #e5e6e8;
`

const IconWrapper = styled.div`
  cursor: pointer;
`

const Title = styled.div`
  margin-left: 16px;
  font-size: 20px;
  color: ${(props) => props.theme.text._1};
`

const ExtraInfo = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px 0;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.text._1};
  background-color: #fff8e8;
  & > div {
    margin-left: 8px;
  }
`
